import React,{ChangeEvent,useState,useCallback,useEffect} from "react";
import "Assets/css/GameMnyDpst.css";
import { useNavigate, useLocation } from "react-router-dom";

const getParamCI = (params: URLSearchParams, key: string): string | null => {
    const targetKey = key.toLowerCase();
    let result: string | null = null;
    params.forEach((v, k) => {
        if (k.toLowerCase() === targetKey) {
            result = v;
        }
    });
    return result;
};

const normalizePchsKindCd = (value: string | null): string => {
    const raw = String(value || "").trim().toUpperCase();
    if (raw === "MNY") {
        return "DPST";
    }
    if (raw === "ITEM" || raw === "DPST") {
        return raw;
    }
    return "DPST";
};

const GameMnyDpstDonUi = () => {
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const dpstOdrNo = getParamCI(urlParams, 'dpstOdrNo');
    const dpstCode = getParamCI(urlParams, 'code');
    const dpstMsg = getParamCI(urlParams, 'msg');
    const closeYn = getParamCI(urlParams, 'closeYn');
    const gameSvcCd = getParamCI(urlParams, 'gameSvcCd') || 'BBO';
    const lang = getParamCI(urlParams, 'langCd') || 'ko';
    const rcmnPrdtCd = getParamCI(urlParams, 'rcmnPrdtCd');
    const pymtMthdNm = getParamCI(urlParams, 'pymtMthdNm');
    const prdtNm = getParamCI(urlParams, 'prdtNm');
    const paidMny = getParamCI(urlParams, 'pm');
    const freeMny = getParamCI(urlParams, 'fm');
    const odrAmt = getParamCI(urlParams, 'oa');
    const pchsKindCd = normalizePchsKindCd(getParamCI(urlParams, 'pchsKindCd') || getParamCI(urlParams, 'prdtKindCd'));
    const effectiveDpstCode = dpstCode || 'PYMT0000';
    const hasResultPayload = Boolean(effectiveDpstCode || dpstMsg || rcmnPrdtCd);
    const getDpstReturnContext = () => {
        try {
            const raw = window.sessionStorage.getItem("shopDpstReturnContext");
            if (!raw) {
                return null;
            }
            return JSON.parse(raw) as {
                gameSvcCd?: string;
                shopKindCd?: string;
                prdtCd?: string;
                pymtMthdCd?: string;
                prdtPrc?: string;
                prdtCnt?: number;
                odrAmt?: string;
            };
        } catch {
            return null;
        }
    };

    const getShopReturnUrl = () => {
        try {
            const parsed = getDpstReturnContext();
            if (!parsed) {
                return null;
            }

            const targetGameSvcCd = String(parsed?.gameSvcCd || gameSvcCd || "BBO");
            const targetShopKindCd = String(parsed?.shopKindCd || (pchsKindCd === "ITEM" ? "SUBS" : "MNY"));
            const params = new URLSearchParams();
            params.set("gameSvcCd", targetGameSvcCd);
            params.set("ctntKindCd", targetShopKindCd);
            params.set("shopKindCd", targetShopKindCd);
            params.set("dpstFromPg", "Y");
            if (dpstOdrNo) params.set("dpstOdrNo", dpstOdrNo);
            if (effectiveDpstCode) params.set("dpstCode", effectiveDpstCode);
            if (dpstMsg) params.set("dpstMsg", dpstMsg);
            if (closeYn) params.set("closeYn", closeYn);
            if (rcmnPrdtCd) params.set("rcmnPrdtCd", rcmnPrdtCd);
            if (prdtNm) params.set("prdtNm", prdtNm);
            if (pymtMthdNm) params.set("pymtMthdNm", pymtMthdNm);
            if (paidMny) params.set("paidMny", paidMny);
            if (freeMny) params.set("freeMny", freeMny);
            if (odrAmt || parsed?.odrAmt) params.set("odrAmt", String(odrAmt || parsed?.odrAmt || ""));
            if (parsed?.prdtCd) params.set("prdtCd", String(parsed.prdtCd));
            if (parsed?.pymtMthdCd) params.set("pymtMthdCd", String(parsed.pymtMthdCd));
            if (parsed?.prdtPrc) params.set("prdtPrc", String(parsed.prdtPrc));
            if (typeof parsed?.prdtCnt !== "undefined") params.set("prdtCnt", String(parsed.prdtCnt));
            if (pchsKindCd) params.set("pchsKindCd", pchsKindCd);
            return `/GamePage/ShopLst?${params.toString()}`;
        } catch {
            return null;
        }
    };

    useEffect(() => {
        const dpstReturnContext = getDpstReturnContext();
        if (window.opener) {
            window.opener.postMessage({
                type: 'dpstResult',
                dpstOdrNo: dpstOdrNo,
                dpstCode: effectiveDpstCode,
                dpstMsg:dpstMsg,
                gameSvcCd: gameSvcCd,
                closeYn: closeYn,
                rcmnPrdtCd: rcmnPrdtCd,
                prdtNm: prdtNm,
                pymtMthdNm: pymtMthdNm,
                paidMny: paidMny,
                freeMny: freeMny,
                odrAmt: odrAmt || dpstReturnContext?.odrAmt,
                prdtCd: dpstReturnContext?.prdtCd,
                pymtMthdCd: dpstReturnContext?.pymtMthdCd,
                prdtPrc: dpstReturnContext?.prdtPrc,
                prdtCnt: dpstReturnContext?.prdtCnt,
                pchsKindCd: pchsKindCd,
            }, '*');
            // 레거시 수신부 호환용
            window.opener.postMessage({
                type: 'navigateToResult',
                dpstOdrNo: dpstOdrNo,
                dpstCode: effectiveDpstCode,
                dpstMsg:dpstMsg,
                gameSvcCd: gameSvcCd,
                closeYn: closeYn,
                rcmnPrdtCd: rcmnPrdtCd,
                prdtNm: prdtNm,
                pymtMthdNm: pymtMthdNm,
                paidMny: paidMny,
                freeMny: freeMny,
                odrAmt: odrAmt || dpstReturnContext?.odrAmt,
                prdtCd: dpstReturnContext?.prdtCd,
                pymtMthdCd: dpstReturnContext?.pymtMthdCd,
                prdtPrc: dpstReturnContext?.prdtPrc,
                prdtCnt: dpstReturnContext?.prdtCnt,
                pchsKindCd: pchsKindCd,
            }, '*');
            window.close();
            return;
        }

        const shopReturnUrl = getShopReturnUrl();
        if (shopReturnUrl) {
            navigate(shopReturnUrl, { replace: true });
            return;
        }

        // opener가 없는 경우 기존 결과 페이지 플로우를 유지한다.
        if (hasResultPayload) {
            navigate('/GameMnyDpstResult', { 
                state: { 
                    dpstOdrNo: dpstOdrNo,
                    dpstCode: effectiveDpstCode,
                    dpstMsg: dpstMsg,
                    gameSvcCd: gameSvcCd,
                    closeYn: closeYn,
                    rcmnPrdtCd: rcmnPrdtCd,
                    prdtNm: prdtNm,
                    pymtMthdNm: pymtMthdNm,
                    paidMny: paidMny,
                    freeMny: freeMny,
                    odrAmt: odrAmt || dpstReturnContext?.odrAmt,
                    prdtCd: dpstReturnContext?.prdtCd,
                    pymtMthdCd: dpstReturnContext?.pymtMthdCd,
                    prdtPrc: dpstReturnContext?.prdtPrc,
                    prdtCnt: dpstReturnContext?.prdtCnt,
                    pchsKindCd: pchsKindCd,
                },
                replace: true 
            });
        }
    }, [dpstOdrNo, effectiveDpstCode, hasResultPayload, dpstMsg, gameSvcCd, closeYn, lang, rcmnPrdtCd, pymtMthdNm, prdtNm, paidMny, freeMny, odrAmt, pchsKindCd, navigate]);
    
    return (
        <>
        <div className="container500 gameMnyDpstWrap">
           <p>충전 완료</p>
        </div>
        </>
    )
}

export default GameMnyDpstDonUi;
